<template lang="pug">
  .view-control-arbitrary-answers
    catalog(:items="tests.items" v-model="selectedTest")
      template(#item="{ item }")
        | {{ item.name }}

      template(#default="{ item }")
        catalog(:items="arbitraryQuestions.items" v-model="selectedQuestion")
          template(#item="{ item }")
            | {{ item.title }}

          template(#default="{ item }")
            catalog(:items="answers.items" v-model="selectedAnswer")
              template(#item="{ item }")
                | {{ item.session.user.fullName }}

              template(#default="{ item }")
                .p-20.content
                  h6 Ответ пользователя
                  blockquote {{ item.input }}
                  b-field(label="Верно")
                    b-switch(v-model="item.correct")
                  button.button.is-primary(@click="updateAnswer(item)" :disabled="item.correct === null") Обновить
</template>

<script>
import Test from '@/models/Test';
import TestQuestion from '@/models/TestQuestion';
import Answer from '@/models/Answer';
import api from '@/api';

export default {
  name: 'view-control-arbitrary-answers',

  data() {
    return {
      tests: Test.collection(),
      selectedTest: null,
      arbitraryQuestions: TestQuestion.collection(),
      selectedQuestion: null,
      answers: Answer.collection(),
      selectedAnswer: null,
    };
  },

  created() {
    this.tests.$fetch();
  },

  watch: {
    selectedTest(test) {
      if (!test) {
        return;
      }

      this.arbitraryQuestions.$fetch({
        filter: {
          test_id: test.id,
          type: 'arbitrary',
        },
      });

      this.selectedQuestion = null;
      this.selectedAnswer = null;
    },

    async selectedQuestion(question) {
      if (!question) {
        return;
      }

      const response = await api.for(`questions/${question.id}/answers/unmarked`).fetch();

      this.answers = Answer.collection(response.data);

      this.selectedAnswer = null;
    },
  },

  methods: {
    async updateAnswer(answer) {
      await answer.$save();

      this.selectedAnswer = null;

      this.answers.items = this.answers.items.filter(
        ans => ans.test_session_id !== answer.test_session_id
      );
    },
  },
};
</script>
